import { CHANGE_USER_PROJECT_AND_JOURNEY_REQUEST } from 'core/userContext/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { WarningBanner } from 'ui/banner';

import { selectProjects } from 'core/userContext';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const DONT_SAVE_BUTTON_TEST_ID = 'dont-save-button';
export const SAVE_AND_SWITCH_BUTTON_TEST_ID = 'save-and-switch-button';
export const SWITCH_BUTTON_TEST_ID = 'switch-button';

export interface IndexSwitchProjectsModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Selected workflow id */
  workflowId: number;
  /** Selected project id */
  projectId: number;
  /** Callback to close the modal */
  onClose: () => void;
}

export const IndexSwitchProjectModal: React.FC<
  React.PropsWithChildren<IndexSwitchProjectsModalProps>
> = ({ workflowId, projectId, onClose }) => {
  const dispatch = useDispatch();
  const projects = useSelector(selectProjects);
  const destinationProjectName = projects?.find((p) => p.id === projectId)?.name;

  const handleGoToJourney = () => {
    dispatch({
      type: CHANGE_USER_PROJECT_AND_JOURNEY_REQUEST,
      projectId,
      workflowId,
      workflowType: 'Draft',
    });
  };

  return (
    <Modal
      id="index-switch-projects-modal"
      isModalOpen
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>Switch projects?</ModalHeader>
      <ModalBody>
        <p>
          To view this journey, you need to be in the <strong>{destinationProjectName}</strong>{' '}
          project. Do you want to switch projects?
        </p>
        <WarningBanner Icon={false}>
          <strong>Heads up!</strong> If you have Iterable open in any other tabs, this will switch
          you to {destinationProjectName} there too.
        </WarningBanner>
      </ModalBody>
      <ModalFooter data-test={`index-switch-projects-modal-${workflowId}-actions`}>
        <Button
          data-test={SWITCH_BUTTON_TEST_ID}
          onClick={handleGoToJourney}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          Switch projects
        </Button>
      </ModalFooter>
    </Modal>
  );
};
